import { Radio, Tooltip } from '@pankod/refine-antd'
import { TriangleAlert } from 'lucide-react'
import React from 'react'

type PageRadioProps = {
  onChange: (value: string, index: number) => void
  showFrontPageAlert?: boolean
  showBackPageAlert?: boolean
}

export const PageRadio = (props: PageRadioProps) => {
  const { onChange, showFrontPageAlert, showBackPageAlert } = props
  return (
    <div className="certificate-template__page-radio absolute top-2 m-2 p-2 rounded shadow z-10 select-none bg-white">
      <Radio.Group
        defaultValue="front"
        buttonStyle="outline"
        size="small"
        onChange={(e) => {
          const indexOfSelected = e.target.value === 'front' ? 0 : 1
          onChange(e.target.value, indexOfSelected)
        }}
      >
        <Radio.Button value="front">
          <div className="flex flex-row items-center">
            Depan
            {showFrontPageAlert && (
              <Tooltip title="Terdapat perubahan yang belum disimpan">
                <TriangleAlert
                  color="white"
                  fill="orange"
                  className="ml-1 "
                  size="18"
                />
              </Tooltip>
            )}
          </div>
        </Radio.Button>
        <Radio.Button value="back">
          <div className="flex flex-row items-center">
            Belakang
            {showBackPageAlert && (
              <Tooltip title="Terdapat perubahan yang belum disimpan">
                <TriangleAlert
                  color="white"
                  fill="orange"
                  className="ml-1 "
                  size="18"
                />
              </Tooltip>
            )}
          </div>
        </Radio.Button>
      </Radio.Group>
    </div>
  )
}
